import { render, staticRenderFns } from "./OnboardingFormView.vue?vue&type=template&id=11b15da8&scoped=true"
import script from "./OnboardingFormView.vue?vue&type=script&lang=ts"
export * from "./OnboardingFormView.vue?vue&type=script&lang=ts"
import style0 from "./OnboardingFormView.vue?vue&type=style&index=0&id=11b15da8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11b15da8",
  null
  
)

export default component.exports